import React from 'react';
import PropTypes from 'prop-types';
import SyntaxHighlighter, { registerLanguage } from 'react-syntax-highlighter/dist/light';
import js from 'highlight.js/lib/languages/javascript';
registerLanguage('javascript', js);

var PreTag = function PreTag(_ref) {
  var children = _ref.children;
  return React.createElement("pre", {
    className: "highlight-block"
  }, children);
};

var CodeTag = function CodeTag(_ref2) {
  var children = _ref2.children;
  return React.createElement("code", {
    className: "hljs javascript"
  }, children);
};

var CodeBlock = function CodeBlock(_ref3) {
  var code = _ref3.code;
  return React.createElement(SyntaxHighlighter, {
    language: "javascript",
    useInlineStyles: false,
    PreTag: PreTag,
    CodeTag: CodeTag
  }, code);
};

CodeBlock.propTypes = {
  code: PropTypes.string
};
PreTag.propTypes = {
  children: PropTypes.node
};
CodeTag.propTypes = {
  children: PropTypes.node
};
export default CodeBlock;